import script from "./esPermissionSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./esPermissionSetting.vue?vue&type=script&lang=ts&setup=true"

import "./esPermissionSetting.vue?vue&type=style&index=0&id=3f909c34&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f909c34"]])

export default __exports__